<template>
  <div class="evaluate">
    <van-nav-bar
      title="评价"
      left-arrow
      @click-left="onClickLeft"
      :right-text="rightText"
      @click-right="publish"
    />
    <div class="container">
      <div class="describe">
        <img :src="oGoods.picUrl" alt="" class="desc_img" />
        <p class="info">{{ oGoods.goodsName }}</p>
      </div>
      <div class="evaluta_star">
        <star
          @change="onChange"
          :bDisable="bDisabled"
          :total="nTotal"
          :b-total="bTotal"
          :a-star="aStar"
        />
      </div>
      <div v-if="bLook" :class="{ none: bDisabled }" class="field">
        <van-field
          :disabled="bDisabled"
          v-model="message"
          rows="2"
          type="textarea"
          maxlength="30"
          placeholder="请输入评价内容，限制30字"
          show-word-limit
        />
      </div>
    </div>
  </div>
</template>

<script>
import star from "./star";
import { Toast } from "vant";

export default {
  name: "evaluate-page",
  data() {
    return {
      rightText: "",
      message: "",
      bTotal: false,
      nTotal: 0,
      bDisabled: false,
      itemList: [],
      aStar: [],
      orderNo: null,
      bLook: true,
      oGoods: {},
    };
  },
  components: {
    star,
  },
  created() {
    this.isRoute();
  },
  methods: {
    isRoute() {
      const { meta, query } = this.$route;
      this.orderNo = query.orderNo;
      if (meta.look) {
        this.metaLook = meta.look;
        // 查看
        this.bDisabled = true;
        this.bTotal = true;
        this.rightText = "";
        this._findByOrderNo({
          type: 0, //查看0 发布1
          orderNo: query.orderNo,
        });
      } else {
        this.rightText = "发布";
        this._findByOrderNo({
          type: 1, //查看0 发布1
          orderNo: query.orderNo,
        });
      }
    },
    _stuSave(data) {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        className: "loading",
        loadingType: "spinner",
        message: "提交中",
      });
      this.$api.evaluate.stuSave({ data }).then((res) => {
        let { data, message } = res;
        Toast.clear();
        if (data) {
          this.$toast({
            message: "发布成功",
          });
          this.onClickLeft();
        } else {
          // this.$toast({
          //   message: message,
          // });
        }
      });
    },

    _findByOrderNo(params) {
      this.$api.evaluate.findByOrderNo(params).then((res) => {
        let { itemList, goodsName, picUrl, content, aveScore } = res.data;
        this.oGoods = {
          goodsName,
          picUrl,
        };
        if (params.type == 1) {
          this.bLook = true;
          this.aStar = [
            { evaluationType: 0, score: 0, evaluationTypeName: "培训课程" },
            { evaluationType: 1, score: 0, evaluationTypeName: "院校环境" },
            { evaluationType: 2, score: 0, evaluationTypeName: "师资规模" },
            { evaluationType: 3, score: 0, evaluationTypeName: "服务态度" },
          ];
        } else {
          this.nTotal = aveScore;
          this.message = content;
          this.aStar = itemList;
          if (content) {
            this.bLook = true;
          } else {
            this.bLook = false;
          }
        }
      });
    },
    publish() {
      let itemList = this.itemList;
      if (itemList.length < 4) {
        this.$toast({
          message: "四个维度星级请评分",
        });
        return;
      }
      this._stuSave({
        orderNo: this.orderNo,
        content: this.message.trim(),
        itemList,
      });
    },
    onClickLeft() {
      this.$router.push("/orderpage");
    },
    onChange(item) {
      this.itemList.push(item);
      this.itemList = [...new Set(this.itemList)];
    },
  },
};
</script>

<style lang="less" scoped>
.evaluate {
  background: #f7f7f7;
  min-height: 100vh;
  /deep/.van-nav-bar__text {
    font-size: 16px;
    color: #407DF7;
  }
  .evaluta_star {
    padding-bottom: 30px;
  }
  .container {
    position: relative;
    margin: 24px;
    background: #fff;
    border-radius: 16px;
    .describe {
      display: flex;
      border-bottom: 1px solid #eaeaea;
      padding: 30px 0;
      margin: 0 30px;
      background: #fff;
      .desc_img {
        width: 242px;
        height: 182px;
        margin-right: 25px;
        border-radius: 16px;
      }
      .info {
        padding-top: 13px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
      }
    }
    .none {
      /deep/ .van-field__word-limit {
        display: none;
      }
    }
    .field {
      padding: 0 30px 30px 30px;
      .van-field {
        font-size: 0.74rem;
        background: #f9faf9;
        border-radius: 12px;
        border: 1px solid #eaeaea;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      /deep/ .van-field__word-limit {
        font-size: 12px;
        color: #999;
      }
      /deep/ .van-field__word-num {
        color: #333;
      }
    }
  }
}
.ellipsis {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
